import * as React from 'react';

import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import { useLocation } from 'wouter';

import { getPostLoginRedirectPath } from '~/shared/routing/authRedirect';

export type SuccessAnimationProps = {
  message?: string;
};

export const SuccessAnimation = ({
  message = 'Success!',
}: SuccessAnimationProps) => {
  const [, setLocation] = useLocation();
  const [animationData, setAnimationData] = React.useState<object>();
  const redirectPath = React.useMemo(() => getPostLoginRedirectPath(), []);

  React.useEffect(() => {
    import('~/shared/animations/check.json').then(setAnimationData);
  }, []);

  return (
    <div className="@SuccessAnimation flex grow flex-col items-center justify-center">
      <Lottie
        play
        className="size-32"
        loop={false}
        onComplete={() => setLocation(redirectPath)}
        animationData={animationData}
      />

      <p className="animate-in text-lg font-medium text-success-darker fade-in">
        {message}
      </p>
    </div>
  );
};
